
export const traineesData = [
  {
    id: 1,
    name: "ريان ثاني أبكر",
    email: "",
    institution: "جامعة الباحة",
    student_id: 443047360,
    identification: null,
    training_hours: 320,
    specilization: "Electric Engineering",
    phone: "+966 53 625 2471",
    start_at: "2025-01-01",
    end_at: "2025-03-31",
    duration: "2 months",
    supervisor: "Eng. Waleed Sabana",
  },
  {
    id:2,
    name: "أحمد فراس إبريق",
    email: "",
    institution: "جامعة الامير مقرن",
    specilization: "Computer Science",
    student_id: 4310502,
    identification: 2232733929,
    training_hours: 320,
    phone: "+966 55 598 1322",
    start_at: "2025-07-01",
    end_at: "2025-09-31",
    duration: "2 months",
    supervisor: "Eng. Basim Thani",
  },
  {
    id: 3,
    name: "عبدالله سعود مراد",
    email: "abssmofficial@gmail.com",
    institution: "جامعة ام القرى",
    specilization: "قسم علوم الحاسب الآلي",
    student_id: null,
    identification: null,
    training_hours: 550,
    phone: "+966 55 426 4336",
    start_at: "2025-07-01",
    end_at: "2025-09-31",
    duration: "2 months",
    supervisor: "Eng. Omer Abullail",
  },
  {
    id: 4,
    name: "فارس سعود العتيبي",
    email: "ffaarrss.9119@gmail.com",
    institution: "جامعة ام القرى",
    specilization: "قسم علوم الحاسب الآلي",
    student_id: null,
    identification: null,
    training_hours: 550,
    phone: "0552160081",
    start_at: "2026-01-25",
    end_at: "2026-06-25",
    duration: "6 months",
    supervisor: "Eng. Omer Abullail",
  },
  {
    id: 5,
    name: "شروق محمد أدم فلاتة",
    email: "shurooq.mohamed@outlook.com",
    institution: "المؤسسة العامة للتدريب التقني المهني",
    specilization: "برمجة وتطوير الويب",
    student_id: null,
    identification: 2491742983,
    training_hours: 550,
    phone: "+966 59 700 4933",
    start_at: "2026-01-25",
    end_at: "2026-06-25",
    duration: "6 months",
    supervisor: "Eng. Basim Thani",
  },
  {
    id: 6,
    name: "طيف عبدالوهاب عبدالله الزهراني",
    email: "taef.abdulwahab@gmail.com",
    institution: "جامعة أم القرى",
    specilization: "Computer Science",
    student_id: 44512026,
    identification: 1114951930,
    training_hours: 550,
    phone: "+966 50 153 0040",
    start_at: "2026-01-25",
    end_at: "2026-06-25",
    duration: "6 months",
    supervisor: "Eng. Basim Thani",
  },
  {
    id: 7,
    name: "عمار الحبشي",
    email: "maroo2012@hotmail.com",
    institution: "الجامعة العربية المفتوحة",
    specilization: "شبكات وأمن المعلومات",
    student_id: 21423517,
    identification: 2205492321,
    training_hours: 128,
    phone: "+966 54 041 9083",
    start_at: "2026-02-01",
    end_at: "2026-04-02",
    duration: "2 months",
    supervisor: "Eng. Walid Siabana",
  },
];